import { React, DomeManipulator } from '@lexriver/dome'
import css from './QuantityChanger.m.scss'
import cssAnimation from '../Animation.m.scss'
import {DomeComponent} from '@lexriver/dome'
import { GlobalState } from '../GlobalState'
import { GlobalUser } from '../GlobalUser'


export enum EnumQuantityChangerStyle{
    InBasket = 'in-basket',
    InProductTiles = 'in-product-tiles',
    InProductList = 'in-product-list',
    InProductPopup = 'in-product-popup',
}

interface Attrs{
    //text:string
    quantity:number
    minQuantity:number
    maxQuantity:number
    type?:EnumQuantityChangerStyle
    onQuantityChange?:(newQuantity:number) => void
}

export class QuantityChanger extends DomeComponent<Attrs>{
    // readonly divContainer:HTMLDivElement = <div class={css.tooltip}></div>
    // readonly spanErrorMessage:HTMLSpanElement = <span></span>
    // readonly spanArrow = <span class={css.tooltipArrow}></span>
    protected refInput:HTMLInputElement|undefined
    //onChangeEvent:TypeEvent<(newQuantity:number)=>void> = new TypeEvent()

    protected isValidQuantity = this.checkIfValidQuantity()

    render(){
        return (
            <div class={css.quantityChanger}>
                <button class={css.minusButton} onClick={() => this.decrement()}><span class="icon-minus-1" /></button>
                <input type="text" ref={ref => this.refInput = ref } class={{[css.invalid]:!this.isValidQuantity}} value={this.attrs.quantity.toString()} onBlur={this.onBlur} />
                <button class={css.plusButton} onClick={() => this.increment()}><span class="icon-plus-1" /></button>
            </div>
        )
    }

    async updateAsync(){
        this.checkIfValidQuantity()
        if(!this.refInput) return
        this.refInput.value = this.attrs.quantity.toString()
        let isValid = this.attrs.maxQuantity === undefined || this.attrs.quantity<=this.attrs.maxQuantity
        DomeManipulator.setCssClasses(this.refInput, {[css.invalid]:!isValid})
    }

    checkIfValidQuantity(){
        const maxIsOk = this.attrs.maxQuantity === undefined || this.attrs.quantity<=this.attrs.maxQuantity
        const minIsOk = this.attrs.minQuantity === undefined || this.attrs.quantity>=this.attrs.minQuantity
        return maxIsOk && minIsOk
    }


    onBlur = (e) => {
        //const inputValue = e.target.value
        const inputValueNumber = this.getQuantity()
        if(inputValueNumber !== this.attrs.quantity){
            this.setQuantity(inputValueNumber, true)
        }
    }

    getQuantity():number{
        if(!this.refInput) throw new Error('no refInput')
        return this.parseInputValue(this.refInput)
    }

    setQuantity(newQuantity:number, triggerEvent:boolean){
        if(this.attrs.quantity == newQuantity) return // already changed
        if(newQuantity<this.attrs.minQuantity) throw new Error(`bad newQuantity=${newQuantity}<${this.attrs.minQuantity}`)
        if(newQuantity>this.attrs.maxQuantity){
            newQuantity = this.attrs.maxQuantity
            alert('Максимальное количество данного товара: '+this.attrs.maxQuantity)
        }
        //if(!this.refInput) throw new Error('no refInput')
        // if(this.attrs.quantity === newQuantity){
        //     // no need to change anything
        //     return
        // }
        this.attrs.quantity = newQuantity
        //this.refInput.value = newQuantity.toString()
        this.scheduleUpdate()
        //this.onChangeEvent.trigger(newQuantity)
        if(triggerEvent && this.attrs.onQuantityChange){
            this.attrs.onQuantityChange(newQuantity)
        }
    }


    protected parseInputValue(refInput:HTMLInputElement){
        return parseInt(refInput.value) || this.attrs.minQuantity
    }
    
    protected increment(){
        if(!this.refInput) return
        const newQuantity = this.parseInputValue(this.refInput)+1
        // we can go above maximum, but show alert later
        this.setQuantity(newQuantity, true)

    }

    protected decrement(){
        if(!this.refInput) return
        const newQuantity = this.parseInputValue(this.refInput)-1
        if(newQuantity>=this.attrs.minQuantity){
            this.setQuantity(newQuantity, true)
        }
    }

}